import React from "react";
import PropTypes from "prop-types";
import "./LoadingSpinner.scss";

function LoadingSpinner({
  bottom = "50%",
  right = "45%",
  height = "130px",
  width = "130px",
  borderWidth = "3px",
}) {
  const styleVars = {
    "--spinnerWidth": width,
    "--spinnerHeight": height,
    "--spinnerBottom": bottom,
    "--spinnerRight": right,
    "--spinnerBorderWidth": borderWidth,
  };
  return <div style={styleVars} className="LoadingSpinner"></div>;
}

LoadingSpinner.propTypes = {
  bottom: PropTypes.string.isRequired,
  right: PropTypes.string,
  borderWidth: PropTypes.string,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};

export default LoadingSpinner;
